module.exports = __webpack_public_path__ + "static/media/dislike-thumb.45045e34.svg";